import { ELMO_EXPERIMENTS } from '../constants'

// Single source of truth for the Partner Setup self-serve pilot gate, used
// by both the sidebar nav item filter and the route itself, so sunsetting
// the Elmo experiment only requires a change here.
export function isPartnerSetupSelfServeEligible(
  enviroment,
  devdashPartnerSetupSelfServeElmoEligibility,
) {
  return (
    enviroment === 'sandbox' &&
    devdashPartnerSetupSelfServeElmoEligibility ===
      ELMO_EXPERIMENTS.DevdashPartnerSetupSelfServeElmoEligibility.Treatment
  )
}
